import api from '../../../services/api';

export const LOGIN_URL = "/auth/login";
export const REGISTER_URL = "/auth/register";
export const REQUEST_PASSWORD_URL = "/auth/forgot-password";

export const ME_URL = "api/me";

export function login(email, password) {
  return api.post(LOGIN_URL, { email, password });
}


export async function getUseAPI(userId) {
    // const retorno = await api.get(`users/${userId}`)
    const retorno = await api.get(`user/odata?$select=id, name, sap, email, SystemRoleId, Status, UserDirectSuperiorId, PhotoUrl&$expand=CompanyRole, factory, SystemRole&$filter=Id+eq+${userId}`);
    return retorno.data
}

export async function getStructureTreeBancoDeDados(factoryId) {
    // const retorno = await api.get(`users/${userId}`)
    console.log('register request for factory tree')
    const retorno = await api.get(`structure/TreesByFactory/${factoryId}`);
    return retorno.data
}


export function register(email, fullname, username, password) {
  return api.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return api.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return api.get(ME_URL);
}
